import { uploadAudio } from './upload-audio';
import { uploadImage } from './upload-image';
import { uploadImageFromUrl } from './upload-image-from-url';
import { uploadVideo } from './upload-video';

type ApiDeclaration = {
    uploadImage: typeof uploadImage;
    uploadImageFromUrl: typeof uploadImageFromUrl;
    uploadAudio: typeof uploadAudio;
    uploadVideo: typeof uploadVideo;
};

export const uploadsApiDeclaration: ApiDeclaration = {
    uploadImage,
    uploadImageFromUrl,
    uploadAudio,
    uploadVideo,
};
